import { VelocityClient, ReferrerInfo } from '@velocity-exchange/sdk';
import BREAKPOINTS from 'src/constants/breakpoints';
import { getReferralLinkDisplay } from 'src/constants/site';

export const getReferrerInfo = async (
	velocityClient: VelocityClient,
	referrerName: string
): Promise<ReferrerInfo | undefined> => {
	let referrerInfo: ReferrerInfo | undefined = undefined;

	if (!velocityClient || !velocityClient.isSubscribed) return undefined;

	if (referrerName) {
		try {
			const referrerNameAccount =
				await velocityClient.fetchReferrerNameAccount(referrerName);

			if (referrerNameAccount) {
				referrerInfo = {
					referrer: referrerNameAccount.user,
					referrerStats: referrerNameAccount.userStats,
				};
			}
		} catch (err) {
			console.log(err);
			return undefined;
		}
	}

	return referrerInfo;
};

export const getStoredReferrerParam = (mobileOnly = false) => {
	if (typeof window === 'undefined') {
		return null;
	}

	const isMobile = window.innerWidth < BREAKPOINTS.SMALL;
	if (!isMobile && mobileOnly) {
		return null;
	}

	const storedReferrerParam = window.localStorage.getItem('referrerParam');
	const storedReferrerAppliedTimestamp = parseInt(
		window.localStorage.getItem('referrerAppliedTimestamp') ?? '0'
	);

	const isExpired =
		isNaN(storedReferrerAppliedTimestamp) ||
		Date.now() - storedReferrerAppliedTimestamp > 1000 * 60 * 60;

	if (!isExpired && storedReferrerParam) {
		return storedReferrerParam;
	} else {
		if (isExpired) {
			window.localStorage.removeItem('referrerParam');
			window.localStorage.removeItem('referrerAppliedTimestamp');
		}
		return null;
	}
};

export const getReferralLink = (accountDecodedName?: string) => {
	if (!accountDecodedName) return '';

	return getReferralLinkDisplay(accountDecodedName);
};

/**
 * X web-intent URL for sharing a referral link. The display link carries no
 * protocol, so add one to keep the post's link clickable.
 */
export const getReferralShareOnXUrl = (referralLink: string) => {
	const url = referralLink.startsWith('http')
		? referralLink
		: `https://${referralLink}`;

	const params = new URLSearchParams({
		text: 'Trading perps on Velocity. Sign up with my link:',
		url,
	});

	return `https://x.com/intent/tweet?${params.toString()}`;
};
